module.exports = [
  ...require('./_magicItemRawList_DMG_w'),
  require('./wand_of_orcus'),
  require('./wave'),
  require('./whelm'),
]
